import React, {useEffect, useRef} from 'react';
import './AppearanceDialog.css';

export default function AppearanceDialog({title, onClose, children}) {
  const ref = useRef(null);
  useEffect(() => {
    const dialog = ref.current;
    dialog.showModal();
    return () => dialog.close();
  }, []);
  return <dialog ref={ref} className="appearance-dialog" aria-label={title}
    onKeyDown={event => {if(event.key === 'Escape') event.stopPropagation();}}
    onCancel={event => {event.preventDefault(); onClose();}}
    onClick={event => {if(event.target === ref.current) onClose();}}>
    <div className="appearance-dialog-shell">
      <header><h2>{title}</h2><button type="button" autoFocus aria-label="סגירה" onClick={onClose}>✕</button></header>
      <div className="appearance-dialog-content">{children}</div>
    </div>
  </dialog>;
}
